import React from 'react';

import { Show } from '@bd-uikit-web/React/Utils';
import { Form, Input } from '@bd-uikit-web/React/Form';
import SimpleModal from '@bd-uikit-web/React/SimpleModal';

import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';

export default class ForgotPassword extends React.Component {
  constructor(props) {
    super();

    this.props = props;
    this.state = {
      sending: false,
      done: false,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    if (bdAuth.isAuthenticated()) {
      rootDispatcher.dispatch('FORGOTPASSWORD');
      this.props.history.push('/');
      return;
    }
  }

  onFormSubmit(data) {
    const apiLink = '/forgot';
    const apiData = data;

    this.setStateSending();
    bdReq.post(apiLink, apiData)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            sending: false,
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }

        this.setState({
          sending: false,
          done: true,
        });
      });
  }

  // @todo move this to a static global place.
  setStateSending() {
    this.setState({
      sending: true,
    });
  }

  render() {
    return (
      <div className="m-bg-image">
        <div className="m-bg-wrapper">
          <img className="m-bg-logo" src="/assets/img/blackdove-logo.png" alt="Blackdove Logo" />
          <h1> Reset Password </h1>
          <div className="m-bg-container">
            <Form onSubmit={this.onFormSubmit}>
              <div className="m-bg-input-wrapper">
                <Input
                  className="m-bg-input-style"
                  type="email"
                  name="email"
                  placeholder="Email address"
                  invalidMsg="Please enter a valid email"
                  required
                />
              </div>
              <div className="m-bg-button-wrapper">
                <button className="m-bg-login-button" type="submit" disabled={ this.state.sending }>
                  Continue
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}
